
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InitialNotice } from '../../Types/InitialNotice/InitialNoticeTypes';
import { getInitialNoticeByFolderId } from '../../Thunks/BuildingInspectorThunks';



interface InitialNoticeSliceState {
    loader: boolean; // for refres pages and inital loadings
    initialNoticeData: InitialNotice|null;
    errorDisplay: string | null;
}

// set inital valus
const initialState : InitialNoticeSliceState = {
    loader: false,
    initialNoticeData: null,
    errorDisplay: '',

}

// set state valu for api response
const initialNoticeSlice = createSlice ({
    name: 'initialNotice',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getInitialNoticeByFolderId.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getInitialNoticeByFolderId.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getInitialNoticeByFolderId.fulfilled, (state, action: PayloadAction<InitialNotice>) => {
                    state.loader = false;
                    state.initialNoticeData = action.payload;
                  })
    }
})

export const {} = initialNoticeSlice.actions
export default initialNoticeSlice.reducer
